<script setup>
import { ecspPersonalComplianceProfileConfig } from '../../account/personal/complianceProfile/ecspComplianceProfile'
import { ecspLegalComplianceProfileConfig } from '../../account/legal/complianceProfile/ecspComplianceProfile'
import AccountPanelLegalComplianceProfileCategory from '../../account/legal/complianceProfile/AccountPanelLegalComplianceProfileCategory.vue'
import { ref } from 'vue'

const currentForm = ref(null)
</script>

<template>
    <div class="overflow-hidden border border-gray-200 bg-white sm:col-span-1 sm:rounded-md">
        <ul role="list" class="ml-0 list-none divide-y divide-gray-200">
            <AccountPanelLegalComplianceProfileCategory
                key="Investor Classification"
                v-model:current-form="currentForm"
                :form="ecspLegalComplianceProfileConfig['Investor Classification']"
                page-key="Investor Classification"
                quick-edit />
            <AccountPanelLegalComplianceProfileCategory
                key="Risk"
                v-model:current-form="currentForm"
                :form="ecspPersonalComplianceProfileConfig['Risk']"
                page-key="Risk"
                quick-edit />
        </ul>
    </div>
</template>

<style scoped></style>
